import React, { useCallback } from 'react';

import { View } from 'react-native';

import { useTranslation } from 'react-i18next';

import {
    RENT_OVERLAY_DESCRIPTION,
    RENT_OVERLAY_RENT_PERIOD,
    RENT_OVERLAY_RENT_PRICE,
} from 'config/testID';

import { PurchaseProduct } from 'store/railsBuilder/reducer.types';

import { isTabletOrWeb, isWeb } from 'utils/responsiveness';
import { applyBoldStyle } from 'utils/strings';

import styles from 'screens/Detail/components/DetailPurchaseDescription/style';

import Text, { ETextCategory, ETextColor } from 'components/Text';

type PurchaseDescriptionProps = {
    product: PurchaseProduct;
    description: string;
};

function DetailPurchaseDescription({
    product,
    description,
}: PurchaseDescriptionProps) {
    const { t } = useTranslation();

    const renderPurchaseDetails = useCallback(
        (detail: string, value: string, testID?: string) => {
            return (
                <View style={styles.container} testID={testID}>
                    <Text
                        color={ETextColor.neutral}
                        category={ETextCategory.body1}
                        style={[styles.description, styles.text, styles.detail]}
                        {...(isWeb && { tabIndex: 0 })}
                    >
                        {t(detail)}
                    </Text>
                    <Text
                        color={ETextColor.neutral}
                        category={ETextCategory.body1}
                        style={[
                            styles.description,
                            styles.text,
                            styles.boldText,
                        ]}
                        {...(isWeb && { tabIndex: 0 })}
                    >
                        {value}
                    </Text>
                </View>
            );
        },
        [],
    );

    return (
        <>
            <Text
                category={ETextCategory.body1}
                color={ETextColor.light_grey}
                numberOfLines={isTabletOrWeb ? 3 : 4}
                testID={RENT_OVERLAY_DESCRIPTION}
                style={[styles.description, styles.text]}
            >
                {applyBoldStyle(t(description))}
            </Text>
            {renderPurchaseDetails(
                'RENT_OVERLAY_RENT_PERIOD',
                `${product.rentalDuration! / 3600} ${t(
                    'SCREEN_RENT_TIME_HOURS',
                )}`,
                RENT_OVERLAY_RENT_PERIOD,
            )}
            {renderPurchaseDetails(
                'RENT_OVERLAY_RENT_PRICE',
                `${product.price.value} ${product.price.currency}`,
                RENT_OVERLAY_RENT_PRICE,
            )}
        </>
    );
}

export default DetailPurchaseDescription;
